import { Toast } from 'vant';

export default {
  components: {
  },
  data() {
    return {
      html: "",
			wx_jsapi_list: [
				'onMenuShareTimeline',
				'onMenuShareAppMessage',
				'hideMenuItems',
				'scanQRCode',
				'getLocation',
				'translateVoice',
				'startRecord',
				'stopRecord',
				'onVoiceRecordEnd',
				'playVoice',
				'pauseVoice',
				'stopVoice',
				'uploadVoice',
				'downloadVoice',
				'chooseImage',
				'uploadImage',
				'downloadImage',
				'getRecorderManager '
			],
			linkcode: '', // 短链code
			detail: '', // 短链详情
			jumpUrl: '',
			isError: false,

			aid: '', //自定义参数
    }
  },
	created() {
		let id = jm.getQueryString('id')
		if (id) {
			this.linkcode = id.slice(1)
			this.getDetail()
		}
		this.aid = jm.getQueryString('aid') || ''
		console.log('aid',this.aid)
	},
  mounted() {
    // this.$nextTick(() => {
		// 	this.getWxConfig()
		// })
  },
  methods: {
    initHtml() {
			let script = document.createElement('script');
			script.type = 'text/wxtag-template'
				script.text = `<button class="btn-box" style="height: 40px;width: 200px;color:#fff; background: #58bd6c; border: none; border-radius: 5px; font-size: 14px;">跳转小程序</button>`
			this.html =
				`<wx-open-launch-weapp style="display: flex; justify-content: center;"
					id="launch-btn"  
					appid="${this.detail.shortlink.app_id}"
					path="${this.jumpUrl}">${script.outerHTML}</wx-open-launch-weapp>`
		},
		getWxConfig() {
			const that = this
			let myUrl = window.location.href;
			if (window.location.href.indexOf("#") > -1) {
				myUrl = window.location.href.split('#')[0];
			}
			this.$axios.get(jm.site.AUTHJEXTRA + '/api/wx/open/jsdk/config', {
				params: {
					app_id: 'wxf2ec881a01d245c9',
					url: myUrl
				}
			}).then(data => {
				if (data.success) {
					wx.config({
						debug: false,
						appId: data.data.appId,
						timestamp: data.data.timeSpan,
						nonceStr: data.data.nonceStr,
						signature: data.data.sinature,
						jsApiList: that.wx_jsapi_list,
						openTagList: ['wx-open-launch-weapp']
					});

					wx.error((res) => {
						var log_content = JSON.stringify(res);
						this.isError = true
						console.log(log_content, 777777)
						this.html = `<button class="btn-box" style="height: 40px;width: 200px;color:#fff; background: #ccc; border: none; border-radius: 5px; font-size: 14px;">不可跳转</button>`
					})

					wx.ready(() => {
						console.log('rrrrrrrr')
						if (this.isError) return
						this.initHtml()
					})
				}
			})
		},

		// 查询小程序短链详情
		getDetail() {
			this.$axios.get(jm.site.WEICHAT_SITE + `/api/v1/weichat/mediaplatform/nanoprogram/h5shortlink/${this.linkcode}`, {
				params: {}
			}).then(data => {
				if (data.success && data.data) {
					this.detail = data.data

					// if (this.detail.shortlink.path.includes('goUrl=')) {
					// 	let urlList = this.detail.shortlink.path.split('goUrl=')
					// 	let url = `${urlList[0]}goUrl=${encodeURIComponent(urlList[1])}&isEncode=1`
	
					// 	this.jumpUrl = url
					// 	console.log(222222, url)
					// } else {
					// 	this.jumpUrl = this.detail.shortlink.path
					// }
					let  jumpUrl = this.detail.shortlink.urlscheme_link;
					if(this.aid){
						jumpUrl += `&cq=aid=${this.aid}`
					}
					this.jumpUrl  = jumpUrl 
					console.log(this.jumpUrl,11111)
				} else {
					Toast(data.msg);
				}
			})
		},

		// 点击跳转
		handleClick() {
			window.location.href = this.jumpUrl
		}
  },
}



// WEBPACK FOOTER //
// ./src/pages/index/index.js